var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIllustrationSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.814 26.262s10.56-.41 12.842-17.239C21.682-5.922 39.489.881 44.636 6.838c6.667 7.718 3.113 20.993 11.738 22.67 8.626 1.678 2.993 20.324-10.1 18.54-16.287-2.221-12.346 7.006-17.236 10.911-3.508 2.803-17.896.105-18.376-10.07-.404-8.562-4.129-8.535-6.77-9.506-3.807-1.4-6.207-11.54 2.922-13.121z",
    fill: "#F0F3FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#B5BEEF",
    d: "M29.37 27.508h19.882v2.724H29.37zM26.919 22.333h31.866v2.724H26.919z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m41.672 45.337-8.296-8.197a1.461 1.461 0 0 0-2.054 2.08l8.295 8.197a1.461 1.461 0 0 0 2.055-2.08z",
    fill: "#465DD8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.065 28.345c0 7.138-5.786 12.924-12.923 12.924-7.138 0-12.924-5.786-12.924-12.924 0-7.137 5.786-12.923 12.924-12.923 7.137 0 12.923 5.786 12.923 12.923zm-1.936-.13c0 5.972-4.841 10.814-10.814 10.814S12.5 34.187 12.5 28.214 17.342 17.4 23.315 17.4s10.814 4.841 10.814 10.814z",
    fill: "#465DD8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationSearch);
export default __webpack_public_path__ + "static/media/IllustrationSearch.20207bbe.svg";
export { ForwardRef as ReactComponent };